const util = require("util");

// all events
// click, mousedown, dblclick, pressmove, pressup, mouseover / mouseout, and rollover / rollout
// stagemousedown, stagemouseup, and stagemousemove

createjs.MouseEvent.CLICK = "click";
createjs.MouseEvent.MOUSE_UP = "pressup";
createjs.MouseEvent.PRESS_MOVE = "pressmove";
createjs.MouseEvent.MOUSE_DOWN = "mousedown";
createjs.MouseEvent.MOUSE_OUT = "mouseout";
createjs.MouseEvent.MOUSE_OVER = "mouseover";
createjs.MouseEvent.ROLL_OVER = "rollover";
createjs.MouseEvent.ROLL_OUT = "rollout";
createjs.MouseEvent.DOUBLE_CLICK = "dblclick";


// does not exist in createJS
createjs.MouseEvent.MOUSE_MOVE = "stagemousemove";
createjs.MouseEvent.STAGE_MOUSE_DOWN = "stagemousedown";
createjs.MouseEvent.STAGE_MOUSE_UP = "stagemouseup";
createjs.MouseEvent.MOUSE_WHEEL = "wheel";


type CombineMouseEvent = createjs.MouseEvent & {
    _shiftKey: boolean | undefined;
    _ctrlKey: boolean | undefined;
    _altKey: boolean | undefined;
    _delta: boolean | undefined;
    nativeEvent: { deltaY: number | undefined }
};

Object.defineProperty(createjs.MouseEvent.prototype, "shiftKey", {
    set: function (this: CombineMouseEvent, value: boolean) {
        this._shiftKey = value;
    },
    get: function (this: CombineMouseEvent): boolean {
        let result = false;
        if (!util.isUndefined(this.nativeEvent)) {
            result = this.nativeEvent.shiftKey;
        } else {
            result = this._shiftKey || false;
        }
        return result;
    },
    enumerable: true,
    configurable: true,
});

Object.defineProperty(createjs.MouseEvent.prototype, "ctrlKey", {
    set: function (this: CombineMouseEvent, value: boolean) {
        this._ctrlKey = value;
    },
    get: function (this: CombineMouseEvent): boolean {
        let result = false;
        if (!util.isUndefined(this.nativeEvent)) {
            result = this.nativeEvent.ctrlKey;
        } else {
            result = this._ctrlKey || false;
        }
        return result;
    },
    enumerable: true,
    configurable: true,
});

Object.defineProperty(createjs.MouseEvent.prototype, "altKey", {
    set: function (this: CombineMouseEvent, value: boolean) {
        this._altKey = value;
    },
    get: function (this: CombineMouseEvent): boolean {
        let result = false;
        if (!util.isUndefined(this.nativeEvent)) {
            result = this.nativeEvent.altKey;
        } else {
            result = this._altKey || false;
        }
        return result;
    },
    enumerable: true,
    configurable: true,
});

Object.defineProperty(createjs.MouseEvent.prototype, "buttonDown", {
    value: false,
    enumerable: true,
    configurable: true,
    writable: true
});

Object.defineProperty(createjs.MouseEvent.prototype, "delta", {
    set: function (this: CombineMouseEvent, value: boolean) {
        this._delta = value;
    },
    get: function (this: CombineMouseEvent): boolean {
        let result;
        if (!util.isUndefined(this.nativeEvent)) {
            result = this.nativeEvent.deltaY;
        } else {
            result = this._delta || 0;
        }
        
        return result as any; // TODO: This getter improperly mangles `number` and `boolean` types
    },
    enumerable: true,
    configurable: true,
});
